export default "__VITE_ASSET__b4658440__"